import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM353.6 304.6c10-3.1 19.3 5.5 17.7 15.3-8 47.1-71.3 80-123.3 80s-115.4-32.9-123.3-80c-1.7-9.9 7.8-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin.js
// module id = 1760
// module chunks = 0